<template>
    <div class="w-full bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-700 p-2 flex flex-col gap-2">
        <div class="w-full h-48 overflow-hidden rounded-xl bg-gray-50 dark:bg-slate-800 relative group cursor-pointer hover:opacity-95 transition-opacity" @click="$emit('open-image-search')">
            
            <div v-if="suggestedImageLoading" class="absolute inset-0 flex items-center justify-center bg-gray-100/50 dark:bg-slate-800/50 z-10">
                <ArrowPathIcon class="w-8 h-8 text-gray-400 animate-spin" />
            </div>

            <div v-if="!playlist.cover && !suggestedImage" class="w-full h-full flex items-center justify-center">
                <PhotoIcon class="w-12 h-12 text-gray-300 dark:text-slate-600" />
            </div>
            
            <img v-else-if="playlist.cover" :src="playlist.cover" class="w-full h-full object-cover border-none" />
            
            <div v-else-if="suggestedImage" class="w-full h-full relative">
                <img :src="suggestedImage" class="w-full h-full object-cover border-none opacity-80" />
                
                <div class="absolute top-2 right-2 flex gap-2">
                    <Tooltip position="bottom" :text="$t('tooltip.refreshImage')">
                        <button 
                            @click.stop="$emit('refresh-suggested', $event)"
                            class="p-2 bg-white/80 hover:bg-white dark:bg-slate-700/80 dark:hover:bg-slate-700 text-gray-700 dark:text-gray-200 rounded-full shadow-md transition-all border-none cursor-pointer"
                        >
                            <ArrowPathIcon class="size-5" />
                        </button>
                    </Tooltip>

                    <Tooltip position="bottom" :text="$t('tooltip.saveImage')">
                        <button 
                            @click.stop="$emit('save-suggested', $event)"
                            class="p-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full shadow-md transition-all border-none cursor-pointer"
                        >
                            <CloudArrowDownIcon class="size-5" />
                        </button>
                    </Tooltip>
                </div>
            </div>
        </div>
        <div class="px-2 pb-1 pt-1 flex justify-between items-center gap-1.5" v-if="playlist.permissions && playlist.permissions.includes('editor')">
            <button @click="$emit('open-image-search')" class="flex-grow text-center text-sm font-semibold text-indigo-700 bg-indigo-50/70 hover:bg-indigo-100 dark:text-indigo-300 dark:bg-indigo-900/30 dark:hover:bg-indigo-900/50 rounded-xl py-2.5 transition-colors cursor-pointer">
                {{ $t('playlistImageCard.changeImage', 'Trocar imagem') }}
            </button>
            <Tooltip v-if="hasAiFeature" position="top" :text="$t('playlistImageCard.generateAi', 'Gerar capa com IA')">
                <button @click="$emit('open-image-search', 'ai')" class="p-2.5 text-indigo-600 dark:text-indigo-300 bg-indigo-50/70 hover:bg-indigo-100 dark:bg-indigo-900/30 dark:hover:bg-indigo-900/50 rounded-xl transition-colors cursor-pointer">
                    <SparklesIcon class="w-5 h-5" />
                </button>
            </Tooltip>
            <button v-if="playlist.cover" @click="$emit('remove-image')" class="p-2.5 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 rounded-xl hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors cursor-pointer">
                <XMarkIcon class="w-5 h-5" />
            </button>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import { PhotoIcon, ArrowPathIcon, CloudArrowDownIcon, XMarkIcon, SparklesIcon } from '@heroicons/vue/24/outline';
import Tooltip from '@/components/common/elements/TriadTooltip.vue';
import userStore from '@/store/user.store';

const hasAiFeature = computed(() => userStore.getters.hasAiFeature);

defineProps({
    playlist: {
        type: Object,
        required: true
    },
    suggestedImage: {
        type: String,
        default: null
    },
    suggestedImageLoading: {
        type: Boolean,
        default: false
    }
});

defineEmits([
    'open-image-search',
    'refresh-suggested',
    'save-suggested',
    'remove-image'
]);
</script>
